export type { BoxProps } from "./Box-styles";
export { default } from "./Box-component";
